export default "__VITE_ASSET__E0le2A5R__"